export interface IItemOutputDto {
    field: string;
    // Para valores planos (string o number)
    value?: number | string;
    // Para drilldowns anidados
    drilldown?: IItemOutputDto[][];
}

export type Row = IItemOutputDto[];

export interface IRankingOutputDto {
    name: string;
    items: Row[];
    metadata?: {
        sortedBy?: string;
        sortDirection?: 'asc' | 'desc';
        total?: number;
        totalTrips?: number;
    };
}
